// @ts-strict-ignore
import { ActivatedRoute, NavigationStart, Params, Router } from '@angular/router';
import { SystemConfigurationService } from '@shared/system-configuration/system-configuration-loading.service';
import { Log } from '@shared/debug/log';
import { SystemConfigurationVO } from '@shared/system-configuration/system-configuration.vo';
import { TouchService } from '../window/touch.service';
import { Injectable, Signal } from '@angular/core';
import { UserActionsLoggingManager } from '@user/service/logging/user-actions-logging.manager';
import { QueryParamsManager } from './query-params.manager';
import { BehaviorSubject } from 'rxjs';
import { UserSessionService } from '@user/service/user-session.service';

@Injectable({ providedIn: 'root' })
export class InitManager {
  public static readonly PROJECT_OPTION_DATA_VERSION: string = '1.1';
  // PROJECT_OPTION_DATA_VERSION in which FSF Norm was included. Before that such property was not used.
  // Versions before are considered to be 1.0, so before introduction of FSF Norm
  public static readonly FSF_NORM_PROJECT_OPTION_DATA_VERSION: string = '1.1';

  public static spacingDecidingValue: number = 1;
  public static labelingScaleFactor: number = 1;

  public static initCompleted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public static localAuthenticationEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); //  Is true in case users can be authenticated by DB


  private _previousUrl: string;

  constructor(
    private touchService: TouchService,
    private router: Router,
    private userActionsLoggingManager: UserActionsLoggingManager,
    private systemConfigurationService: SystemConfigurationService,
    private route: ActivatedRoute,
    private queryParamsManager: QueryParamsManager,
    private userSessionService: UserSessionService,
  ) {}

  public get isCdcAvailable(): Signal<boolean> {
    return this.userSessionService.isCdcAvailable;
  }

  public async init() {
    this.queryParamsManager.createEShopTransferHandler();
    this.touchService.init();
    this.setRoutingClass();
    await this.systemConfigurationService.loadSystemConfiguration();
    await this.continueInitComplete(this.systemConfigurationService.currentConfiguration);
  }

  private setRoutingClass(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this._previousUrl) {
          document.body.classList.remove(this._previousUrl);
        }
        const currentUrlSlug = event.url.substr(event.url.lastIndexOf('/') + 1);
        if (currentUrlSlug) {
          document.body.classList.add(currentUrlSlug);
        }
        this._previousUrl = currentUrlSlug;
      }
    });
  }

  private async continueInitComplete(systemConfiguration: SystemConfigurationVO): Promise<void> {
    InitManager.labelingScaleFactor = systemConfiguration.labelingScaleFactor;
    InitManager.spacingDecidingValue = systemConfiguration.spacingDecidingValue;
    InitManager.localAuthenticationEnabled.next(systemConfiguration.localAuthenticationEnabled);
    await this.userSessionService.initCdc(systemConfiguration);
    this.initDebug(systemConfiguration.debugToolsEnabled);
    this.userActionsLoggingManager.init(systemConfiguration.userActionsLoggingSynchronisationDelay);
    InitManager.initCompleted.next(true);
  }

  private initDebug(debugToolsEnabled: boolean): void {
    this.route.queryParams.subscribe((params: Params) => {
      const isDeactivateDebugInfo = params['deactivateDebugInfo'] === 'true';
      if (isDeactivateDebugInfo || !debugToolsEnabled) {
        Log.forceDeactivate();
      }
    });
  }
}
